import EditCoDept from "./Edit";

export default function AddCoDept() {
    return <EditCoDept mode="add" />;
}
